import React, { useContext } from 'react'
// @ts-ignore
import { useTranslation } from 'react-i18next'
import { Box, Button, Flex, Heading, Text } from 'rebass'
import {
  trackHandler,
  UneeqContext,
  useDisableBodyOverflow,
  useUneeqState
} from 'uneeq-react-core'

import { MayaOverlay } from '../MayaOverlay'
import styles from './styles'
import QuestionMark from '../MayaIcons/QuestionMark'
interface MayaConfirmLeaveProps {
  onConfirm: () => any
}

const MayaConfirmLeave = React.memo(({ onConfirm }: MayaConfirmLeaveProps) => {
  const { confirmLeaveOpen } = useUneeqState()
  const { dispatch } = useContext(UneeqContext)
  const { t } = useTranslation()

  useDisableBodyOverflow(confirmLeaveOpen)

  const closeConfirmLeave = () => dispatch({ type: 'mayaCloseConfirmLeave' })
  const handleConfirm = () => {
    onConfirm()
    closeConfirmLeave()
  }

  if (!confirmLeaveOpen) return null

  return (
    <MayaOverlay>
      <Flex sx={styles.container}>
        <Box sx={{ pt: 8, pb: 12 }}>
          <QuestionMark />
        </Box>
        <Heading variant="title" sx={styles.heading}>
          {t('LeaveSession.title')}
        </Heading>
        <Text sx={styles.text}>{t('LeaveSession.subtitle')}</Text>
        <Flex sx={styles.buttonsContainer}>
          <Button
            autoFocus
            id="confirm"
            variant="alertInverted"
            onClick={trackHandler(handleConfirm, 'exit-session-btn')}
          >
            {t('LeaveSession.confirm')}
          </Button>
          <Button
            id="cancel"
            variant="alertPrimary"
            sx={styles.backToChatButton}
            onClick={closeConfirmLeave}
          >
            {t('LeaveSession.dismiss')}
          </Button>
        </Flex>
      </Flex>
    </MayaOverlay>
  )
})

export default MayaConfirmLeave
